import(/* webpackMode: "eager", webpackExports: ["FeedPostClient"] */ "/vercel/path0/app/feed/[slug]/feed-client.tsx");
